export default {
  "path": "/demo/amap",
  "meta": {
    "name": "demo-地图",
    "title": "地图",
    "isComponentDoc": true,
    "category": "Introduce"
  }
};